import anne from "../../assets/team/frasekonsulenter/anne.jpg";
import emil from "../../assets/team/frasekonsulenter/emil.jpg";
import mia from "../../assets/team/frasekonsulenter/mia.jpg";
import mikkel from "../../assets/team/frasekonsulenter/mikkel-bak.jpg";
import sarah from "../../assets/team/frasekonsulenter/sarah.jpg";
import simone from "../../assets/team/frasekonsulenter/simone.jpg";
import daniel from "../../assets/team/frasekonsulenter/daniel.jpg";
import anneLouise from "../../assets/team/frasekonsulenter/anne-louise.jpg";

export default function SammarbejdsPartner() {
  return (
    <section className="container mx-auto">
      <div className="frase-konsulent-section mt-16 md:mb-16">
        <div className="flex flex-col border-t items-center justify-between md:flex-row py-16 mx-auto">
          <div className="mr-0 md:w-7/12 h-min w-100">
            <h2 className="max-w-2xl md:max-w-none text-dxl md:text-[25px] font-bold text-doctio-green">
              Teamet af læger og speciallæger
            </h2>

            <p className="max-w-2xl md:max-w-none font-medium">
              Hos Doctio samarbejder vi med et stærkt hold af fagligt dygtige
              læger, speciallæger og andet sundhedspersonale inden for
              forskellige specialer for at tilbyde fraser og journalkoncepter af
              højeste kvalitet. Vil du være en del af holdet?
            </p>
          </div>
          <div className="md:w-1/4 lg:flex mt-8 md:mt-0 items-center justify-end">
            <a
              href="https://doctio.dk/teamet"
              className="text-white transition-colors button-shadow duration-300 ease-in-out font-bold w-[20.5rem] block rounded-full hover:bg-white hover:text-doctio-green bg-doctio-green focus:outline-none px-4 py-2 text-center"
            >
              Bliv frasekonsulent
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-screen-xl">
        <div className="grid gap-x-20 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          <div className="items-center mb-16 md:mb-24">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={anne}
              alt="Anne Grethe Schioldan - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green mb-0 pt-4">
                Anne Grethe Schioldan
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Speciallæge i almen medicin og PhD
              </h4>
              <p className="text-dbase">
                Anne Grethe har medvirket til gennemlæsning af
                børne-undersøgelserne.
              </p>
            </div>
          </div>
          <div className="items-center mb-16 md:mb-24">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={emil}
              alt="Emil Gulløv - Doctio"
            />
            <div>
              <h3 className="text-dlg font-bold text-doctio-green mb-0 pt-4">
                Emil Gulløv
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Læge, hoveduddannelse indenfor almen medicin.
              </h4>
              <p className="text-dbase ">
                Emil har erfaring inden for kardiologen og almen medicin, og er
                forfatter til en stor del af de alment medicinske fraser.
              </p>
            </div>
          </div>
          <div className="items-center mb-16 md:mb-24">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={mia}
              alt="Mia Ravn Jacobsen - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green mb-0 pt-4">
                Mia Ravn Jacobsen
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Læge og PhD-studerende i hjertemedicinske sygdomme
              </h4>
              <p className="text-dbase ">
                Mia er aktuelt igang med at skrive Ph.D. indenfor kardiologien.
                Mia er forfatter til hjertestopsfrasen.
              </p>
            </div>
          </div>
          <div className="items-center mb-16 md:mb-24">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={mikkel}
              alt="Mikkel Bak Jensen - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green mb-0 pt-4">
                Mikkel Bak Jensen
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Læge, Introduktionsstilling ved Hudafdeling og Allergicenter
              </h4>
              <p className="text-dbase ">
                Mikkel er forfatter til flere af de dermatologiske fraser.
              </p>
            </div>
          </div>
          <div className="items-center mb-16 md:mb-32">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={daniel}
              alt="Daniel Bomark - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green mb-0 pt-4">
                Daniel Bomark
              </h3>
              <h4 className="text-dbase mb-8 font-bold">Læge</h4>
              <p className="text-dbase ">
                Daniel har erfaring fra bl.a. ortopædkirurgi, akutmedicin,
                mavetarmkirurgi, almen medicin samt telemedicin.
              </p>
            </div>
          </div>
          <div className="items-center mb-16 md:mb-32">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={sarah}
              alt="Sarah Knudsen - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green mb-0 pt-4">
                Sarah Knudsen
              </h3>
              <h4 className="text-dbase mb-8 font-bold">
                Læge, Introduktionsstilling i Endokrinologi
              </h4>
              <p className="text-dbase ">
                Sarah har erfaring inden for almen medicin og endokrinologi, og
                er forfatter til flere af de endokrinologiske fraser.
              </p>
            </div>
          </div>
          <div className="items-center mb-16 md:mb-32">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={anneLouise}
              alt="Anne Louise Spenning - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green mb-0 pt-4">
                Anne - Louise Spenning
              </h3>
              <h4 className="text-dbase mb-8 font-bold">Læge</h4>
              <p className="text-dbase ">
                Anne er introduktionslæge i dermatologi. Hun har erfaring inden
                for geriatri, akut medicin, almen praksis, onkologi og
                dermatologi.
              </p>
            </div>
          </div>
          <div className="items-center mb-16 md:mb-32">
            <img
              className="w-full rounded-[12px] picture-shadow"
              src={simone}
              alt="Simone Bundgaard Mark - Doctio"
            />

            <div>
              <h3 className="text-dlg font-bold text-doctio-green mb-0 pt-4">
                Simone Bundgaard Mark
              </h3>
              <h4 className="text-dbase mb-8 font-bold">Medicinstuderende</h4>
              <p className="text-dbase ">
                Simone læser primært korrektur på fraserne.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
